const otc = {
    state: {
        formData: {
            //showFooter: false //是否展示底部按钮
        },
        selectedData: {

        },
    },
    mutations: {
        setFormData(state, obj) {
            state.formData = obj;
            localStorage.setItem("formData", JSON.stringify(obj));
        },
        setSelectedData(state, obj) {
            state.selectedData = obj;
            localStorage.setItem("selectedData", JSON.stringify(obj));
        },
        delFormData(state) {
            state.formData = {};
            localStorage.removeItem("formData");
        }
    },
    getters: {
        getFormData(state) {
            if (localStorage.getItem("formData")) {
                state.formData = JSON.parse(localStorage.getItem("formData"));
            }
            return state.formData;
        },
        getSelectedData(state) {
            if (localStorage.getItem("selectedData")) {
                state.selectedData = JSON.parse(localStorage.getItem("selectedData"));
            }
            return state.selectedData;
        }
    }
};
export default otc;



// WEBPACK FOOTER //
// ./src/store/otc/index.js